import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { ChallengesProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const CHALLENGES_QUERY = graphql`
query NodeAllChallengesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Challenges" } }) {
    nodes {
      data
    }
  }
}
`;

export const ChallengesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(CHALLENGES_QUERY), 'items')}>{children}</Provider>;
};
